
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 95.69 167.98"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Calque 2"}},[_c('path',{attrs:{"fill":"#82a043","d":"M44.5 0h45.2v145.38H44.5z"}}),_c('path',{attrs:{"fill":"#fbfbfb","d":"M54.26 11.12h27.16v20.71H54.26z"}}),_c('path',{attrs:{"fill":"#93ad5c","d":"M38.99 145.38h56.7v22.6h-56.7z"}}),_c('circle',{attrs:{"cx":"67.84","cy":"44.3","r":"5","fill":"#f31512"}}),_c('path',{attrs:{"d":"M62.85 44.3v-8.2h10v8.2s0-4.92-5-5-5 5-5 5z","fill":"#00324e"}}),_c('circle',{attrs:{"cx":"67.84","cy":"62.52","r":"9.24","fill":"#00324e"}}),_c('circle',{attrs:{"cx":"67.84","cy":"62.52","r":"5.91","fill":"#88b309"}}),_c('path',{attrs:{"fill":"#ffc441","d":"M70.29 82.9l2.69 2.48-7.33 7.33 5.93 2.92-7.65 7.65 5.28-7.01-7.28-3.18 8.36-10.19z"}}),_c('path',{attrs:{"d":"M70.29 119.05v-5.24s-.5-10.27-11.76-10.12-24.83 1.89-33.91.64S7.11 98.47 3.33 80.57c0 0-5.52-24.8 18.15-30.76 0 0 4.87-2 20.65-2.3V45S26 44.68 18.24 48-4 58.24 1.06 82c0 0 1.62 24.51 24.64 25 0 0 14.48.42 32.21-.73 0 0 10.73-.57 9.88 12.84a4.85 4.85 0 012.5-.06z","fill":"#a8a7aa"}}),_c('path',{attrs:{"d":"M72.49 112.56h-7.75v23.8s-.22 6.33 3.88 6.22 3.87-4 3.87-6.66z","fill":"#d3d3d3"}}),_c('path',{attrs:{"d":"M44.5 40.74s-3.22 1.14-3.13 5.61 3.13 5.86 3.13 5.86z","fill":"#79787d"}})])])
          )
        }
      }
    